import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "../Contexte/LanguageContext";
import { useTraduction } from "../Contexte/TraductionContext";

function NavBar() {
  const { language } = useLanguage()
  const { contentUrl, contentNav } = useTraduction()
  const [burgerStatut, setburgerStatut] = useState(false)

  const handleClickBurger = () =>{
    setburgerStatut(!burgerStatut)
  }

  const flags = {
    fr: (
      <Link key="fr" to={"https://convoyeurs-renau.fr"}>
        <img loading="lazy" src={"../../../Assets/visuels/images/navigation/fr.webp"} alt="Langue Française"/>
      </Link>
    ),
    en: (
      <Link key="en" to={"https://conveyors-renau.com"}>
        <img loading="lazy" src={"../../../Assets/visuels/images/navigation/en.webp"} alt="English language"/>
      </Link>
    ),
    es: (
      <Link key="es" to={"https://transportadores-renau.es"}>
        <img loading="lazy" src={"../../../Assets/visuels/images/navigation/es.webp"} alt="Lengua española"/>
      </Link>
    ),
    cat: (
      <Link key="cat" to={"http://renau.cat"}>
        <img loading="lazy" src={"../../../Assets/visuels/images/navigation/cat.webp"} alt="Llengua catalana"/>
      </Link>
    ),
  };

  const sortedFlags = [
    flags[language],
    ...Object.values(flags).filter((flag) => flag.key !== language),
  ];

  return (
    <header id="MainHeader">
      <nav>
        <div className="container">
          <Link to={"/"}>
            <img loading="lazy" src={"../../../Assets/visuels/images/logo/renauRed.svg"} alt="Logo Renau" />
          </Link>
          <ul>
            <li>
              <Link to={contentUrl.societe}>{contentNav.Societe}</Link>
            </li>
            <li>
              <Link to={contentUrl.Famille}>{contentNav.Convoyeur}</Link>
            </li>
            <li>
              <Link to={contentUrl.Blog}>{contentNav.Blog}</Link>
            </li>
            <li>
              <Link to={contentUrl.Contacter}>
                <button className="btn-small btn-red">{contentNav.Contacter}</button>
              </Link>
            </li>
            <li className="NavFlag">
              <div className="containerFlag">{sortedFlags}</div>
            </li>
          </ul>
          <div className="responsive-menu">
            <li className="NavFlag NavFlag-responsive">
              <div className="containerFlag">{sortedFlags}</div>
            </li>
            <li onClick={handleClickBurger}>
              <svg  className="burger" xmlns="http://www.w3.org/2000/svg" width="22" height="16" viewBox="0 0 22 16" fill="none" role="button" tabIndex="0">
                <path d="M0.778346 0.0731312C-0.0678212 0.449206 -0.268394 1.67772 0.40854 2.31704C0.822222 2.70565 0.126484 2.68058 10.713 2.68058C21.2995 2.68058 20.6037 2.70565 21.0174 2.31704C21.6191 1.74666 21.5377 0.668582 20.8545 0.198489L20.5975 0.01672L10.7819 0.0041842C2.70886 -0.00835162 0.935044 0.0041842 0.778346 0.0731312Z" fill="#181818"/>
                <path d="M0.922678 6.71717C0.565407 6.84253 0.389906 6.98042 0.195601 7.26874C0.0451709 7.49439 0.0263672 7.58841 0.0263672 8.01462C0.0263672 8.45338 0.0451709 8.52233 0.214404 8.77304C0.320959 8.9172 0.534068 9.11151 0.684498 9.19926L0.966553 9.35596H10.7132H20.4597L20.7418 9.19926C20.8922 9.11151 21.1053 8.9172 21.2119 8.77304C21.3811 8.52233 21.3999 8.45338 21.3999 8.00836C21.3999 7.56334 21.3811 7.49439 21.2119 7.24367C21.1053 7.09951 20.8922 6.9052 20.7418 6.81745L20.4597 6.66076L10.8072 6.64822C2.86573 6.63568 1.11072 6.64822 0.922678 6.71717Z" fill="#181818"/>
                <path d="M0.778654 13.4552C-0.161532 13.8877 -0.274354 15.2353 0.571813 15.8182L0.828797 16H10.7133H20.5978L20.8548 15.8182C21.538 15.3481 21.6194 14.2701 21.0177 13.6997C20.604 13.3111 21.2998 13.3361 10.7008 13.3361C1.41798 13.3361 1.01683 13.3424 0.778654 13.4552Z" fill="#181818"/>
              </svg>
            </li>
            
          </div>
        </div>
      </nav>
      <div className="responsive-nav" 
      
      style={{
        transform: burgerStatut ? "translateX(0%)" : "translateX(100%)", 
        WebkitTransform: burgerStatut ? "translateX(0%)" : "translateX(100%)",
        MozTransform: burgerStatut ? "translateX(0%)" : "translateX(100%)"
      }}>
        <ul>
            <li>
              <Link to={contentUrl.societe}>{contentNav.Societe}</Link>
            </li>
            <li>
              <Link to={contentUrl.Famille}>{contentNav.Convoyeur}</Link>
            </li>
            <li>
              <Link to={contentUrl.Blog}>{contentNav.Blog}</Link>
            </li>
            <li>
              <Link to={contentUrl.Contacter}>
                <button className="btn-small btn-red">{contentNav.Contacter}</button>
              </Link>
            </li>
          </ul>
      </div>
    </header>
  );
}

export default NavBar;
